var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { observer } from "mobx-react";
import { BetsChunk } from "../BetsChunk";
let RenderBets = class RenderBets extends React.PureComponent {
    constructor(renderBetProps) {
        super(renderBetProps);
    }
    render() {
        return (React.createElement(React.Fragment, null, this.props.chunkHeights.map((height, i) => {
            return (React.createElement(BetsChunk, { displayBets: this.props.displayBets, height: height, chunkIndex: i, setBetHeight: this.props.setBetHeight, chunkSize: this.props.chunkSize, key: i }));
        })));
    }
};
RenderBets = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], RenderBets);
export { RenderBets };
//# sourceMappingURL=RenderBets.js.map